export var FIRST_AXES_VIEW = 'first-axes-view';
export var SECOND_AXES_VIEW = 'second-axes-view';
//# sourceMappingURL=constant.js.map